import { ConsignmentStockOutPrintPage } from "@/features/consignment-stockout/pages/ConsignmentStockOutPrintPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockout/$id/print")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["consignment_stock_out.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentStockOutPrintPage,
});
